import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Clock, LogOut, XCircle, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";
import { LegalDisclaimer } from "../components/LegalDisclaimer";

export default function PendingApproval() {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  const rejected = user?.status === "rejected";

  const doLogout = async () => { await logout(); navigate("/login"); };
  const check = async () => {
    const u = await refreshUser();
    if (u?.status === "approved") {
      navigate(u.role === "medico" ? "/medico" : "/isf");
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <div className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center">
          <div className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ${rejected ? "bg-red-50 text-red-500" : "bg-amber-50 text-amber-500"}`}>
            {rejected ? <XCircle className="h-7 w-7" /> : <Clock className="h-7 w-7" />}
          </div>
          <h1 className="mt-5 font-heading text-2xl font-800 text-slate-900">
            {rejected ? "Richiesta non approvata" : "Account in attesa di approvazione"}
          </h1>
          <p className="mt-3 text-sm text-slate-500">
            {rejected
              ? "La tua richiesta di registrazione non è stata approvata. Per maggiori informazioni contatta l'amministrazione della piattaforma."
              : "Grazie per esserti registrato. Il tuo account è in attesa di moderazione da parte dell'Amministratore. Riceverai una notifica via email non appena sarà abilitato."}
          </p>
          <div className="mt-4 rounded-lg bg-slate-50 p-3 text-left text-sm">
            <p className="text-slate-700"><span className="text-slate-400">Nome:</span> {user?.nome} {user?.cognome}</p>
            <p className="text-slate-700"><span className="text-slate-400">Ruolo:</span> {user?.role === "medico" ? "Medico" : "Informatore Scientifico"}</p>
            <p className="text-slate-700"><span className="text-slate-400">Email:</span> {user?.email}</p>
          </div>
          <div className="mt-6 flex flex-col gap-2">
            {!rejected && (
              <Button onClick={check} className="w-full rounded-full bg-blue-700 hover:bg-blue-800" data-testid="check-status-btn">
                <RefreshCw className="mr-2 h-4 w-4" /> Verifica stato
              </Button>
            )}
            <Button variant="outline" onClick={doLogout} className="w-full rounded-full" data-testid="pending-logout-btn">
              <LogOut className="mr-2 h-4 w-4" /> Esci
            </Button>
          </div>
        </div>
      </div>
      <div className="mx-auto w-full max-w-md px-4 pb-8">
        <LegalDisclaimer variant="bar" />
      </div>
    </div>
  );
}
